import React from 'react';
import PropTypes from 'prop-types';
import { utilService } from '../../../common/utils';

function generateAnchorWithIFrameSrc(iFrame) {
  var anchor = document.createElement('a');
  anchor.href = iFrame.src;
  anchor.classList.add(
    'd-inline-block',
    'bg-secondary',
    'rounded-xs',
    'rounded-top-0',
    'p-3',
    'h4',
    'text-dark'
  );
  anchor.setAttribute('target', '_blank');
  anchor.setAttribute('ref', 'noopener noreferrer');
  anchor.innerHTML =
    'Open shared Google Drive <i class="fa fa-external-link"></i>';
  utilService.insertAfter(anchor, iFrame);
}

function ContentHTML({ htmlContent }) {
  const decodedHTMLString = utilService.htmlDecode(htmlContent);
  const tempDivElement = document.createElement('div');
  tempDivElement.innerHTML = decodedHTMLString;
  const allIframeElements = tempDivElement.querySelectorAll('iframe');
  if (allIframeElements.length) {
    [...allIframeElements].forEach((iframe) => {
      iframe.classList.add(
        'border',
        'border-pear',
        'border-2',
        'rounded-xs',
        'rounded-bottom-left-0'
      );
      iframe.parentNode.classList.add('lh-0');
      generateAnchorWithIFrameSrc(iframe);
    });
  }
  return (
    <div
      className="flex-fill pg-tab-content"
      dangerouslySetInnerHTML={{
        __html: tempDivElement.innerHTML,
      }}
    />
  );
}

ContentHTML.propTypes = {
  htmlContent: PropTypes.string.isRequired,
};

export default ContentHTML;
